

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _auth = require('xo-models/src/auth');

require('xo-page-components/src/value-props/directive');

require('xo-title/dist/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-ui-components/src/message/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _bml = require('xo-models/src/bml');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlSignaturePage', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {
                $scope.init = function () {
                    $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
                    $('.paypalHeaderWrapper').addClass('paypalCredit');
                    $('.paypalHeader').removeClass('span14');
                    $('.paypalHeader').addClass('span24');
                    $('.paypalHeader').addClass('headerBar');
                    $scope.token = _angular.$rootScope.token;
                    $scope.bmlSign = new _bml.$BMLApplicationModel();
                };

                $scope.onSubmit = function () {
                    var application_id = $scope.bml.application_id;
                    $scope.bmlSign.application_id = application_id;
                    $scope.bmlSign.action('sign', {
                        resultModel: $scope.bml,
                        success: function success(result) {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                };

                $scope.redirectToReview = function () {
                    _uiRouter.$state.go('checkout.review');
                };

                $scope.init();
            });
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_uiRouter.$state;

_auth.$AuthModel;

_bml.$BMLApplicationModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/directive.js
// module id = ../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/directive.js
// module chunks = 0